module.exports = __webpack_public_path__ + "img/logo-denver-business-journal.7adfcd8e.png";